// reducers
function navigation(state = {}, action) {
  switch (action.type) {
    case 'NAVIGATION_DATA_SUCCESS':
      return action.navigation ? { 
          ...state, 
          isFetching: false,
          ...action.navigation
      } : state;

    case 'ADD_STORE_DETAILS': {
      const newState = { ...state };
      newState.childDetails = newState.childDetails ? newState.childDetails : [];
      newState.childDetails.push(action.storenavigation);
      return newState;
    }
    case 'FETCH_CATEGORY_NAVIGATION': {
      return {
        ...state,
        newNavigationEnabled: action?.newNavABEnabled || false,
        isFetching: true
      }
    }
    case 'FETCH_CATEGORY_NAVIGATION_FAILED': {
      return {
        ...state,
        isFetching: false
      }
    }
    default:
      return state;
  }
}

export default navigation;
